"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeInterceptor = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const ThemeInterceptor = ({ setThemeUrl, }) => {
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const themeUrl = searchParams.get('personalization') || undefined;
    (0, react_1.useEffect)(() => {
        if (themeUrl) {
            setThemeUrl(themeUrl);
        }
    }, []);
    return null;
};
exports.ThemeInterceptor = ThemeInterceptor;
